function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4d4d4d",
  d: "M27 8h-6a2 2 0 00-2 2v3a1 1 0 001 1h1v-4h6v4h1a1 1 0 001-1v-3a2 2 0 00-2-2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#b3b3b3",
  d: "M41 12H7a2 2 0 00-2 2v24a2 2 0 002 2h34a2 2 0 002-2V14a2 2 0 00-2-2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#78909C",
  d: "M9 11h3v1H9zm27 0h3v1h-3z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "gray",
  d: "M13 12h2v28h-2zm20 0h2v28h-2z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.922 15.456a4 4 0 100 8 4 4 0 100-8z",
  fill: "#666"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.922 27.941l-12.554 6.515-2.446-4.483 12.554-6.517z",
  fill: "#999"
});

var Svg19Suitcase = function Svg19Suitcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg19Suitcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/19-suitcase.5e6ba3fd.svg";
export { ForwardRef as ReactComponent };